import React from 'react';
import styles from './UIGameTradeCreatorProposal.module.scss';
import clsx from 'clsx';
import { UIGameTradeCreatorProposalWantedHalf } from './UIGameTradeCreatorProposalWantedHalf.tsx';
import { UIGameTradeCreatorProposalOfferedHalf } from './UIGameTradeCreatorProposalOfferedHalf.tsx';
export const UIGameTradeCreatorProposal = ({ className, offeredCards, wantedCards, onClickOfferedCard, onClickWantedCard, isPortraitLayout })=>/*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.tradeCreatorProposalContainer, className, {
            [styles.portraitLayout]: isPortraitLayout
        })
    }, /*#__PURE__*/ React.createElement(UIGameTradeCreatorProposalWantedHalf, {
        wantedCards: wantedCards,
        onClickWantedCard: onClickWantedCard,
        isPortraitLayout: isPortraitLayout
    }), /*#__PURE__*/ React.createElement(UIGameTradeCreatorProposalOfferedHalf, {
        offeredCards: offeredCards,
        onClickOfferedCard: onClickOfferedCard,
        isPortraitLayout: isPortraitLayout
    }));
